export default {
    getLatest: 'forex/getLatest'
};